// extracted by mini-css-extract-plugin
export var chatHtmlText = "_k4-2";
export var chatLink = "_k4-0";
export var chatText = "_k4-1";